const FooterOperator = () => {
  return (
    <footer className="xl:container xl:mx-auto md:px-6 text-[10px] flex justify-between pb-10 text-gray-600">
      <div>Development v1.0.1</div>
      <div>
        TotalEnergies MVIP &copy;
        {new Date().getFullYear() === 2024 ? "" : "2024 - "}{" "}
        {new Date().getFullYear()}
      </div>
    </footer>
  );
};

export default FooterOperator;

